import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=15ffdc30&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"
import style0 from "./Campaign.vue?vue&type=style&index=0&id=15ffdc30&prod&lang=scss&scoped=true"
import style1 from "./Campaign.vue?vue&type=style&index=1&id=15ffdc30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ffdc30",
  null
  
)

export default component.exports